/**
 * NolaCoin GraphQL API 型定義
 *
 * getWalletクエリで取得するコイン残高情報、Fish商品関連、Fish履歴関連の型定義
 */

/**
 * ウォレット情報
 * getWalletクエリのレスポンス型
 */
export interface Wallet {
  /** ユーザーID */
  userId: string;
  /** 現在の使用可能残高（Fish残高として使用） */
  amount: number;
  /** 総残高（履歴情報含む） */
  totalAmount: number;
  /** 残高の内訳詳細 */
  walletBreakdown: WalletBreakdown[];
}

/**
 * ウォレット残高内訳
 */
export interface WalletBreakdown {
  /** コインの種類 */
  coinType: CoinType;
  /** 該当タイプの残高 */
  amount: number;
}

/**
 * コインタイプ列挙
 */
export enum CoinType {
  /** 基本コイン */
  BASE = "BASE",
  /** プリペイドコイン Web用 */
  PREPAID_WEB = "PREPAID_WEB",
  /** プリペイドコイン iOS用 */
  PREPAID_IOS = "PREPAID_IOS",
  /** プリペイドコイン Android用 */
  PREPAID_ANDROID = "PREPAID_ANDROID",
  /** ボーナスコイン */
  BONUS = "BONUS",
}

/**
 * Fish商品情報
 */
export interface FishProduct {
  /** 商品ID */
  id: string;
  /** Fish数量 */
  amount: number;
  /** 価格（円） */
  price: number;
  /** ボーナスFish数量 */
  bonus: number;
  /** 通貨 */
  currency: string;
}

/**
 * ListFishPackage API用の入力パラメータ
 */
export interface ListFishPackageInput {
  platform: string;
}

/**
 * ListFishPackage API用のGraphQLクエリレスポンス
 */
export interface ListFishPackageResponse {
  listFishPackage: FishProduct[];
}

/**
 * Fish履歴アイテム
 */
export interface FishHistoryItem {
  /** ユーザーID */
  userId: string;
  /** 取引ID */
  transactionId: string;
  /** Fish数量（正：取得、負：利用） */
  amount: number;
  /** 取引種別 */
  transactionType: FishTransactionType;
  /** エントリー内訳 */
  entryBreakdown?: EntryBreakdown[];
  /** 参照ID（注文IDなど） */
  referenceId?: string;
  /** 作成日時 */
  createdAt: string;
  /** 更新日時 */
  updatedAt: string;
}

/**
 * エントリー内訳
 */
export interface EntryBreakdown {
  /** エントリーID */
  entryId: string;
  /** 数量 */
  amount: number;
  /** 有効期限 */
  expiredAt?: string;
  /** コインタイプ */
  coinType?: CoinType;
}

/**
 * Fish取引種別
 */
export enum FishTransactionType {
  /** 購入 */
  PURCHASE = "PURCHASE",
  /** 月次付与 */
  GIVE = "GIVE",
  /** 運営付与 */
  PROMO = "PROMO",
  /** 機能利用 */
  USE = "USE",
  /** 有効期限切れ */
  EXPIRED = "EXPIRED",
  /** 残高調整 */
  ADJUST = "ADJUST",
  /** エラーによる操作の取消 */
  ROLLBACK = "ROLLBACK",
  /** データ修正 */
  MANUAL = "MANUAL",
  /** アカウント削除 */
  DELETE = "DELETE",
}

/**
 * Fish履歴リスト取得用の入力パラメータ
 */
export interface ListTransactionHistoryInput {
  /** 取得件数（デフォルト: 100, 最大: 100） */
  limit?: number;
  /** ページネーション用のlastKey */
  lastKey?: string;
}

/**
 * Fish履歴リスト取得のレスポンス
 */
export interface ListTransactionHistoryOutput {
  /** 履歴アイテムリスト */
  items: FishHistoryItem[];
  /** 次のページ用のlastKey */
  lastKey?: string;
}
